export function extractDomainFromEmail(email: string) {
  const atIndex = email.indexOf('@');
  const domain = email.slice(atIndex + 1);
  return domain;
}
